import { Note } from "../../../src/classes";
import { userInfo } from "./user";

export const alternateStringsInfo = new Note({
  note: "A place for Notes",
  title: "Example Note",
  userInfo,
});
